import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from 'DesignSystem/Buttons';
import classNames from 'classnames';
import ModalTertiaryButton from 'DesignSystem/FormSwiftModal/ModalTertiaryButton';
import ModalSecondaryButton from 'DesignSystem/FormSwiftModal/ModalSecondaryButton';

const ModalActions = (props) => {
  const {
    isCtaSectionVisible,
    primaryCta,
    secondaryCta,
    tertiaryBtn,
  } = props;

  if (!isCtaSectionVisible) {
    return null;
  }

  const {
    btnCopy,
    className,
    onClick,
  } = primaryCta;

  const primaryClasses = classNames(
    'ds-modal-primary-btn',
    className,
  );


  return (
    <div className="ds-modal-btn-container">
      <div className="ds-modal-cta-row">
        <ModalSecondaryButton {...secondaryCta} />
        <div className="ds-modal-primary-btn-container">
          <PrimaryButton
            className={primaryClasses}
            onClick={onClick}
          >
            {btnCopy}
          </PrimaryButton>
        </div>
      </div>
      <ModalTertiaryButton {...tertiaryBtn} />
    </div>
  );
};

ModalActions.defaultProps = {
  isCtaSectionVisible: true,
  secondaryCta: {},
  tertiaryBtn: {},
};

ModalActions.propTypes = {
  isCtaSectionVisible: PropTypes.bool,
  primaryCta: PropTypes.shape({
    btnCopy: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
  }).isRequired,
  secondaryCta: PropTypes.shape({
    btnCopy: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
  }),
  tertiaryBtn: PropTypes.shape({
    btnCopy: PropTypes.string,
    className: PropTypes.string,
    leadingCopy: PropTypes.string,
    onClick: PropTypes.func,
    variation: PropTypes.oneOf([
      '',
      'alternative',
    ]),
  }),
};

export default ModalActions;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/FormSwiftModal/ModalActions.jsx